<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

<div class="reptile-price">
    {@render children?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-price {
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-12;
        align-items: baseline;

        width: 100%;

        text-align: left;
    }
</style>
